export default class OccupiedMeetingRoomView {
    constructor(json) {
        this.id = json.id;
        this.initials = json.initials;
        this.message = json.message;
        this.profileImage = json.profileImage;
    }
}
